<form [formGroup]="form" autocomplete="off">
  @if (!selectedSubscription || !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row margin-bottom-x2">
      <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
        <span></span>
        <app-info
          tooltip="Den dato hvorfra en serviceaftale er gældende. En serviceaftale startes normalt - men ikke nødvendigvis - op fra d.d."
        ></app-info>
      </div>
      <mat-form-field appearance="outline" color="primary">
        <mat-label>Startdato</mat-label>
        <input #input matInput [matDatepicker]="picker" formControlName="startDate" (dateChange)="onStartDateChanged($event)" />
        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint>
          dd+n eller dd-n kan bruges i dette felt.
          <br />
          F.eks. dd+14 vil give en dato som er 14 dage fra dags dato.
        </mat-hint>
      </mat-form-field>
    </div>
  }
  @if (!selectedSubscription || !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Næste eftersyn</mat-label>
        <mat-datepicker-toggle matPrefix [for]="checkupPicker"></mat-datepicker-toggle>
        <input matInput #checkupInput [matDatepicker]="checkupPicker" [min]="getMinCheckupDate()" formControlName="nextCheckupDate" />
        <mat-datepicker #checkupPicker></mat-datepicker>
      </mat-form-field>
      @if (isanlaegNewlyInstalled) {
        <div>
          Eftersyn vil blive kørt indenfor 12 måneder efter installation af anlæg: Check venligst om dette er korrekt oprettet?
        </div>
      }
    </div>
  }
  @if (selectedSubscription && !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row margin-bottom-x2">
      <mat-label>Eftersynsinterval:</mat-label>
      <span>{{ selectedSubscription.eftersynInterval }} Måneder</span>
    </div>
  }
  @if (!selectedSubscription || !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row">
      <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
        <span></span>
        <app-info tooltip="En beskrivelse der automatisk sendes med til næste (førstkommende) eftersyn."></app-info>
      </div>
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Beskrivelse til næste eftersyn</mat-label>
        <textarea formControlName="serviceOrderNote" rows="4" matInput></textarea>
        <mat-hint align="end">
          <app-character-count [control]="serviceOrderNote" [maxlength]="500"></app-character-count>
        </mat-hint>
        @if (serviceOrderNote.hasError('maxlength')) {
          <mat-error>
            Beskrivelse til næste eftersyn må højest være 500 karakterer lang
          </mat-error>
        }
      </mat-form-field>
    </div>
  }
  <div>
    @if (!partners || partners?.length == 0) {
      <mat-error>Det er så yndigt at følges ad. En serviceaftale kan ikke oprettes uden en partner.</mat-error>
    }
    @if (partners?.length > 0) {
      @if (partners?.length == 1) {
        Partner: {{ partners[0].partner.name }}
      }
      @if (partners?.length > 1) {
        <div class="form-row">
          <app-partner-input [form]="form" [partners]="partners" (selectedPartner)="onSelectedPartnerChange($event)"></app-partner-input>
        </div>
      }
    }
  </div>
  <div>
    @if (canWrite) {
      <div class="form-row">
        <app-henviser-input [form]="form" [henvisere]="henvisere"></app-henviser-input>
      </div>
    }
  </div>
  <div class="form-row">
    <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
      <span></span>
      <app-info
        tooltip="En serviceaftale har tilknyttet et abonnement. Abonnementet er styrende for, hvor tit der køres eftersyn og for prissætningen heraf."
      ></app-info>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Abonnement</mat-label>
      <mat-select formControlName="abonnementId" (selectionChange)="onSubscribtionChange($event.value)">
        @for (subscribtion of subscribtions; track subscribtion) {
          <mat-option [value]="subscribtion.id">{{ subscribtion.description }}</mat-option>
        }
      </mat-select>
      <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
    </mat-form-field>
  </div>

  <div class="form-row">
    <div class="flex-wrap flex-wrap--between flex-wrap--align-bottom">
      <span></span>
      <app-info
        tooltip="En note der automatisk sendes med til s-partner (OK Energiteknik eller ekstern partner) på såvel tilkald som eftersyn."
      ></app-info>
    </div>
    <mat-form-field appearance="outline" class="mdc-textarea-fix">
      <mat-label>Fast note til s-partner/tekniker</mat-label>
      <textarea formControlName="fastOrdreNote" rows="4" matInput></textarea>
      <mat-hint align="end">
        <app-character-count [control]="fastOrdreNote" [maxlength]="500"></app-character-count>
      </mat-hint>
      @if (fastOrdreNote.hasError('maxlength')) {
        <mat-error>Fast note til s-partner/tekniker må højest være 500 karakterer lang</mat-error>
      }
    </mat-form-field>
  </div>

  @if (!selectedSubscription || !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Opkrævningsdato</mat-label>
        <mat-datepicker-toggle matPrefix [for]="opkraevningsPicker"></mat-datepicker-toggle>
        <input #opkraevningsInput matInput [matDatepicker]="opkraevningsPicker" [min]="minPaymentDate" formControlName="opkraevningDate" />
        <mat-datepicker #opkraevningsPicker></mat-datepicker>
      </mat-form-field>
      @if (opkraevningDate?.value >= maxPaymentDate) {
        <mat-error>
          Advarsel: Opkrævningsdato ligger udenfor aftalens opkrævningsinterval
        </mat-error>
      }
    </div>
  }
  @if (selectedSubscription && !selectedSubscription.isTilkaldsabonnement) {
    <div class="form-row margin-bottom-x2 flex">
      <mat-label class="margin--right-xs">Opkrævningsinterval:</mat-label>
      @if (!opkraevningsinterval.value) {
        <span>{{ selectedSubscription.opkraevningInterval }} måneder</span>
      }
      @if (opkraevningsinterval.value) {
        <span
          [matTooltipDisabled]="opkraevningsinterval.value == selectedSubscription.opkraevningInterval"
      [matTooltip]="
        'Opkrævningsintervallet afviger fra det normale på ' + selectedSubscription.opkraevningInterval + ' måneder via abonnementet'
      "
          >
          {{ opkraevningsinterval.value }} måneder
        </span>
      }
      <button
        type="button"
        class="btn-icon inline-flex margin--left-xs"
        matTooltip="Rediger opkrævningsinterval"
        (click)="openOpkraevningsIntervalDialog()"
        >
        <mat-icon class="blue" svgIcon="edit"></mat-icon>
      </button>
      @if (opkraevningsinterval.value) {
        <button
          (click)="clearOpkraevningsInterval()"
          class="btn-icon red margin--left-xs"
          aria-label="Fjern specielt opkrævningsinterval"
          matTooltip="Fjern specielt opkrævningsinterval"
          >
          <mat-icon svgIcon="delete"></mat-icon>
          Fjern specielt opkrævningsinterval
        </button>
      }
      @if (form.errors?.opkraevningsinterval) {
        <mat-error>
          Abonnementets Eftersynsinterval skal være deleligt med det angivne Opkraevningsinterval.
        </mat-error>
      }
    </div>
  }
  @for (tag of tags; track tag) {
    <div class="form-row" (click)="$event.stopPropagation()">
      <mat-slide-toggle color="primary" (change)="onTagToggle(tag.id)">
        {{ tag.text }}
      </mat-slide-toggle>
    </div>
  }
</form>
